(() => {
  const SECTION_SELECTOR = '.product-recently-viewed--section';
  const CARD_SELECTOR = '.product-recently-viewed-card';
  const CONTAINER_SELECTOR = '[data-recently-viewed-container]';

  const equalizeHeights = (section) => {
    const cards = section.querySelectorAll(CARD_SELECTOR);

    if (!cards.length) {
      return;
    }

    cards.forEach((card) => {
      card.style.height = 'auto';
    });

    let maxHeight = 0;

    cards.forEach((card) => {
      maxHeight = Math.max(maxHeight, Math.ceil(card.getBoundingClientRect().height));
    });

    if (!maxHeight) {
      return;
    }

    cards.forEach((card) => {
      card.style.height = `${maxHeight}px`;
    });
  };

  const initSection = (section) => {
    if (section.dataset.recentlyViewedHeightReady === 'true') {
      equalizeHeights(section);
      return;
    }

    section.dataset.recentlyViewedHeightReady = 'true';

    const run = () => {
      window.requestAnimationFrame(() => equalizeHeights(section));
    };

    run();
    window.addEventListener('resize', run, { passive: true });
    section.addEventListener('rimg:load', run);

    const container = section.querySelector(CONTAINER_SELECTOR);

    if (container) {
      const observer = new MutationObserver(run);
      observer.observe(container, { childList: true, subtree: true });
    }
  };

  const initAllSections = () => {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', initAllSections);
})();
